// Virtual Account DTOs
export interface CreateVirtualAccountDto {
    guardianId: string;
}

export interface VirtualAccountDto {
    id: string;
    guardianId: string;
    guardianName: string;
    accountNumber: string;
    accountName: string;
    bankName: string;
    reference: string;
    isActive: boolean;
    createdAt: string;
    lastPaymentAt?: string;
}

export interface GuardianWithoutBvnDto {
    id: string;
    fullName: string;
    phoneNumber: string;
    email: string;
    studentCount: number;
}

export interface GuardianWithoutVaDto {
    id: string;
    fullName: string;
    phoneNumber: string;
    email: string;
    hasBvn: boolean;
    studentCount: number;
}

// Virtual Account service functions that use axios from useAxios hook
export const virtualAccountService = {
    async getSchoolVirtualAccounts(axiosClient: any, schoolId: string) {
        const response = await axiosClient.get(`/api/virtualaccount/school/${schoolId}`);
        return response.data;
    },

    async getGuardiansWithoutBvn(axiosClient: any, schoolId: string) {
        const response = await axiosClient.get(`/api/virtualaccount/guardians-without-bvn/${schoolId}`);
        return response.data;
    },

    async getGuardiansWithoutVa(axiosClient: any, schoolId: string) {
        const response = await axiosClient.get(`/api/virtualaccount/guardians-without-va/${schoolId}`);
        return response.data;
    },

    async createVirtualAccount(axiosClient: any, data: CreateVirtualAccountDto) {
        const response = await axiosClient.post(`/api/virtualaccount`, data);
        return response.data;
    },

    async bulkCreateVirtualAccounts(axiosClient: any, schoolId: string) {
        const response = await axiosClient.post(`/api/virtualaccount/bulk-create/${schoolId}`);
        return response.data;
    }
};
